// extracted by mini-css-extract-plugin
export default {"Swatch":"colorSwatch_Swatch__T03Ua","Popover":"colorSwatch_Popover__etjOc"};